<template>
  <div class="sports">
    <titlePage :message="{ch:'新闻动态',en:'NEW AND TRENDS'}" :layout="{isBack:true,height:'221px',paddingTop:'81px',top:'75px'}"></titlePage>
    <div class="sports_top">
      <div class="sports_top_left">
        <!-- <moduleTitle :show='true' :message="{title:'新闻资讯',en:'NEWS INFORMATION'}"></moduleTitle> -->
        <slideshow :pictureList='pictureList'></slideshow>
      </div>
      <div class="sports_top_right">
        <moduleTitle :show='true' @click="more()" :message="{title:'通知公告',en:'ANNOUNCEMENT'}"></moduleTitle>
        <News></News>
      </div>
    </div>
    <div class="sports_center">
      <titlePage :message="{ch:'热门推荐',en:'POPULAR RECOMMEND'}" :layout="{isBack:false,height:'221px',paddingTop:'81px',top:'75px'}"></titlePage>
      <div class="sports_center_content">
        <el-row :gutter="36">
          <el-col :span="8" v-for="(item,index) in hotRecommendList" :key="index">
            <el-card shadow="always">
              <div class="sports_center_content_card" @click="skip(item.path)">
                <img :src="item.img" alt="">
                <p>
                  <span>
                    {{item.name}}
                  </span>
                  <img src="../assets/images/new_image/home/icon_left.png" alt="">
                </p>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="sports_bottom">
      <titlePage :message="{ch:'常见问题',en:'COMMON PROBLEM'}" :layout="{isBack:false,height:'251px',paddingTop:'81px',top:'75px'}"></titlePage>
      <div class="sports_bottom_content">
        <commonProblems :isShowPagination='isShowPagination'></commonProblems>
        <div class="sports_bottom_more" @click="questionMore()">
          查看更多
        </div>
      </div>
    </div>
    <el-tooltip placement="top" content="返回顶部">
      <back-to-top 
        transitionName="fade"
        :customStyle="myBackToTopStyle" 
        :visibilityHeight="300" 
        :backPosition="50">
      </back-to-top>
    </el-tooltip>
  </div>
</template>
<script>
import headComponent from "../components/headComponent.vue";

import titlePage from './../components/title.vue'
import moduleTitle from './../components/moduleTitle.vue'
import BackToTop from './../components/backToTop.vue'
import News from './../components/news.vue'
import slideshow from './../components/slideshow.vue'
import commonProblems from '../components/commonProblems.vue'

import {selectPicture} from '@/api/home'
export default {
  name: "home",
  components: {
    headComponent,
    titlePage,
    moduleTitle,
    BackToTop,
    News,
    slideshow,
    commonProblems
  },
  data() {
    return {
      loadings:false,
      pictureList:[],
      myBackToTopStyle: {
        'right': '100px',
        'bottom': '150px',
        'width': '40px',
        'height': '40px',
        'border-radius': '20px',
        'line-height': '40px', 
        'background': '#fff'
      },
      hotRecommendList:[{img:require('../assets/images/new_image/home/pic1.png'),name:'学校体育场地设施开放',path:'schoolSite'},{img:require('../assets/images/new_image/home/pic2.png'),name:'厦门市智慧健身房',path:'wisdomGym'},{img:require('../assets/images/new_image/home/pic3.png'),name:'厦门社会体育指导员驿站',path:'politicalPost'},{img:require('../assets/images/new_image/home/pic4.png'),name:'厦门市体育赛事活动',path:'matchActivity'},{img:require('../assets/images/new_image/home/pic5.png'),name:'厦门市免费低收费场馆',path:'freeVenue'},{img:require('../assets/images/new_image/home/pic6.png'),name:'全民健身地图',path:'fitnessMap'},],
      isShowPagination:false
    };
  },
  methods: {
    // 更多
    more(){
      this.$router.push({name:'newsNotice',query:{type:'home'}})
    },
    // 常见问题更多
    questionMore(){
      this.$router.push({name:'commonMessage'})  
    },
    selectPicture(){//轮播图
      selectPicture().then(res=>{
        console.log(res,"数据1");
        if(res.code == 200){
          this.pictureList = res.result
          console.log(this.pictureList,"数据");
        }
      })
    },
    // 热门详情跳转
    skip(path){
      this.$router.push({name:path})
    },
  },
  mounted(){
  },
  created() {
    this.selectPicture()
  },
  mounted() {},
  computed: {},
  beforeDestroy() {}
};
</script>
<style  lang="less" >
.sports {
  // height: 1292px;
  .sports_top {
    width: 100%;
    // height: 430px;
    margin: 0 auto;
    width: 1198px;
    overflow: hidden;
    // background-color: #969696;
    .sports_top_left {
      float: right;
      position: relative;
      width: 46%;
      height: 430px;
      // background-color: #558589;
      
    }
    .sports_top_right {
      float: left;
      width: 46%;
      height: 430px;
      // background-color: #232332;
      .sports_top_right_title {
        height: 59px;
        width: 100%;
        border-bottom: 1px solid #e5e5e5;
        .sports_top_right_title_left {
          display: inline-block;
          box-sizing: border-box;
          // padding-left: 20px;
          text-align: center;
          height: 59px;
          line-height: 59px;
          width: 111px;
          color: #25b1f7;
          border-top: 2px solid #25b1f7;
        }
        .sports_top_right_title_right {
          cursor: pointer;
          display: inline-block;
          text-align: center;
          float: right;
          box-sizing: border-box;
          // padding-right: 19px;
          height: 59px;
          line-height: 59px;
          width: 111px;
          color: #999999;
        }
      }
    }
  }
  .sports_center{
    background: #F8F8F8;

    &_content{
      width: 1198px;
      margin: 0 auto;
      padding-bottom: 40px;

      .el-card__body{
        padding: 0;
      }

      .el-card{
        margin-bottom: 32px;
      }

      .el-card:hover{
        transform: translateY(-20px);
      }

      &_card{
        cursor: pointer;

        >img{
          width: 100%;
          height: 339px;
        }

        p{
          padding: 22px 25px;
          font-size: 16px;
          color: #333;
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-weight: 500;

          >img{
            width: 21px;
            height: 21px;
          }
        }
      }
    }
  }
  .sports_bottom{
    background: #fff;

   
    &_more{
      margin: 0 auto 30px;
      width: 121px;
      height: 42px;
      background: rgba(0, 0, 0, 0);
      border: 1px solid #E5E5E5;
      border-radius: 21px;
      line-height: 42px;
      color: #666666;
      font-size: 18px;
      text-align: center;
      cursor: pointer;
    }
  }
  .el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
  margin-top: 25px;
  height: 120px;
  display: flex;
}
.row-bg {
  padding: 10px 0;
  // background-color: #f9fafc;
}
}

</style>



// WEBPACK FOOTER //
// src/pages/home.vue